let origin = window.location.origin

export default {
  getOrigin() {
    switch (origin) {
      case 'http://localhost:8080':
      case 'https://localdevshop.bulletin.co':
      case 'https://devshop.bulletin.co':
        return 'develop'

      case 'https://stageshop.bulletin.co':
        return 'stage'

      case 'https://local.bulletin.co':
      case 'https://bulletin.co':
        return 'prod'
    }
  },

  algolia() {
    switch (origin) {
      case 'http://localhost:8080':
      case 'https://localdevshop.bulletin.co':
      case 'https://devshop.bulletin.co':
      case 'https://stageshop.bulletin.co':
        return {
          appId: 'C27IKO5C3J',
          token: '311f647be7e38c1e500ee05962c2787c'
        }

      case 'https://local.bulletin.co':
      case 'https://bulletin.co':
        return {
          appId: '3ILKBK4XB6',
          token: '58f07d980dd16d0423322ca96aa03915'
        }
    }
  },

  mixpanelToken() {
    switch (origin) {
      case 'http://localhost:8080':
      case 'https://localdevshop.bulletin.co':
      case 'https://devshop.bulletin.co':
        return '3b56342926b1a80a7b8e0c0a481b5825'

      case 'https://stageshop.bulletin.co':
        return '3b56342926b1a80a7b8e0c0a481b5825'

      case 'https://local.bulletin.co':
      case 'https://bulletin.co':
        return '5533ac71c0107b1f22000893874db7ac'
    }
  },

  apiUrl() {
    switch (origin) {
      case 'http://localhost:8080':
        return 'https://api-develop.bulletin.co'

      case 'https://localdevshop.bulletin.co':
        return 'https://api-develop.bulletin.co'

      case 'https://devshop.bulletin.co':
        return 'https://api-develop.bulletin.co'

      case 'https://stageshop.bulletin.co':
        return 'https://api-stage.bulletin.co'

      case 'https://local.bulletin.co':
      case 'https://bulletin.co':
        return 'https://api.bulletin.co'
    }
  },

  feedApiUrl() {
    switch (origin) {
      case 'https://localdevshop.bulletin.co':
        return 'http://127.0.0.1:5000'

      case 'http://localhost:8080':
        return 'https://feed-develop.bulletin.co'

      case 'https://devshop.bulletin.co':
        return 'https://feed-develop.bulletin.co'

      case 'https://stageshop.bulletin.co':
        return 'https://feed-stage.bulletin.co'
      case 'https://local.bulletin.co':
      case 'https://bulletin.co':
        return 'https://feed.bulletin.co'
    }
  },

  googleAnalytics() {
    var origin = this.getOrigin()

    switch (origin) {
      case 'localdev':
      case 'develop':
        return 'UA-88243972-4'

      case 'stage':
        return 'UA-88243972-3'

      case 'prod':
        return 'UA-88243972-2'
    }
  },

  googleAnalyticsV4() {
    switch (origin) {
      case 'http://localhost:8080':
      case 'https://devshop.bulletin.co':
        return '344136847'
      case 'https://stageshop.bulletin.co':
        return '344136847'
      case 'https://bulletin.co':
        return '343360398'
    }
  },

  shouldAuthenticateFeed() {
    const origin = this.getOrigin()

    switch (origin) {
      case 'prod':
        return true
      default:
        return false
    }
  },

  pusherOptions() {
    const origin = this.getOrigin()

    switch (origin) {
      case 'stage':
        return {
          key: '07013de949570d954dc5',
          options: {
            cluster: 'mt1'
          }
        }

      case 'prod':
        return {
          key: '63a9264c79a0a7bc38b9',
          options: {
            cluster: 'mt1'
          }
        }

      case 'develop':
      default:
        return {
          key: '0d7f16500f7265124e74',
          options: {
            cluster: 'mt1'
          }
        }
    }
  },

  // Determines if localStorage should be used for access token storage
  // By default, only localhost uses localStorage while all other environments use in-memory storage
  useLocalStorageForToken() {
    // Check if in-memory storage is explicitly requested (overrides default behavior)
    if (process.env.VUE_APP_FORCE_INMEMORY_TOKEN === 'true') {
      return false
    }

    // return true for localStorage on localhost for easier development
    return origin === 'http://localhost:8080'
  },
  async getPersonifyLoginUrl(eventId) {
    const origin = this.getOrigin()

    const PERSONIFY_URL = 'https://prod.personifyauth.com/connect/authorize'
    const CLIENT_ID = 'a2z_events_private_client_emerald_bulletin'
    const PROMPT = 'login'
    const REDIRECT_PATH = '/a2z/connect'
    const RESPONSE_TYPE = 'code+token'
    const SCOPE = 'openid+profile+idp_api+a2z_events_api'
    const CODE_CHALLENGE_METHOD = 'S256'
    const TENANT_ID = 'd41c8ffa-8747-4d74-b7b8-8d925ca45fab'
    const STATE = eventId
    const NONCE = this.generateNonce()
    const CODE_CHALLENGE = await this.generateCodeChallenge(NONCE)
    let REDIRECT_URI = ''

    switch (origin) {
      case 'localdev':
      case 'develop':
      case 'stage':
        REDIRECT_URI = 'https://devshop.bulletin.co' + REDIRECT_PATH
        break
      case 'prod':
        REDIRECT_URI = 'https://bulletin.co' + REDIRECT_PATH
        break
    }
    return `${PERSONIFY_URL}?client_id=${CLIENT_ID}&prompt=${PROMPT}&redirect_uri=${encodeURIComponent(
      REDIRECT_URI
    )}&response_type=${RESPONSE_TYPE}&scope=${SCOPE}&nonce=${NONCE}&state=${STATE}&code_challenge=${CODE_CHALLENGE}&code_challenge_method=${CODE_CHALLENGE_METHOD}&tenantId=${TENANT_ID}`
  },
  generateNonce() {
    return Math.random().toString(36).substring(2) + Date.now().toString(36)
  },
  async generateCodeChallenge(codeVerifier) {
    const encoder = new TextEncoder()
    const data = encoder.encode(codeVerifier)
    const hashBuffer = await crypto.subtle.digest('SHA-256', data)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    return btoa(String.fromCharCode(...hashArray))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '')
  }
}
